var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseEntity } from "../../../pages/modules/base-entity";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { BindingEngine, autoinject, transient } from "aurelia-framework";
import { NotificationClientService } from "../../../../services/basics/notification-client.service";
import { EventAggregator } from "aurelia-event-aggregator";
import { Router } from "aurelia-router";
import { I18N } from "aurelia-i18n";
import { EntityTypes } from "../../../../models/basics/basics.models";
import { RouterConstants } from "../../../../configuration/router.constants";
import { WinningNominationClaimClientService } from "../../../../services/modules/winning-nomination-claim-client.service";
import "../../../plugins/workflow-activities/platform-admin-activity/activity-assignment";
import "../../../plugins/workflow-activities/brand-admin-activity/activity-assignment";
import "../../../plugins/workflow-activities/insurer-activity/activity-assignment";
import "../../../plugins/workflow-activities/credit-player-activity/activity-assignment";
import { InstantGameWinningClaimBasicMeta } from "./steps/basic-meta";
var InstantGameWinningNominationClaimVM = /** @class */ (function (_super) {
    __extends(InstantGameWinningNominationClaimVM, _super);
    function InstantGameWinningNominationClaimVM(dialogClientService, winningNominationClaimBasicMeta, winningNominationClaimClientService, router, bindingEngine, notificationService, eventAggregator, i18N) {
        var _this = _super.call(this, router, bindingEngine, i18N, notificationService, eventAggregator) || this;
        _this.dialogClientService = dialogClientService;
        _this.winningNominationClaimBasicMeta = winningNominationClaimBasicMeta;
        _this.winningNominationClaimClientService = winningNominationClaimClientService;
        _this.router = router;
        _this.bindingEngine = bindingEngine;
        _this.notificationService = notificationService;
        _this.eventAggregator = eventAggregator;
        _this.selectedTab = 'workflow';
        return _this;
    }
    InstantGameWinningNominationClaimVM.prototype.selectTab = function (tab) {
        this.selectedTab = tab;
    };
    InstantGameWinningNominationClaimVM.prototype.getSteps = function () {
        var _this = this;
        return [
            {
                title: this.i18N.tr("game-player-basic-meta"),
                step: 1,
                vm: this.winningNominationClaimBasicMeta,
                show: true,
                getModel: function () { return ({ item: _this.item }); },
                view: "../../app/admin/instant-game-winning-claim/steps/basic-meta.html"
            }
        ];
    };
    // Inherited
    InstantGameWinningNominationClaimVM.prototype.getItem = function (id) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.winningNominationClaimClientService.getInstantGameWinningClaim(id).then(function (response) {
                resolve(response.winningClaim);
            });
        });
    };
    InstantGameWinningNominationClaimVM.prototype.getItemId = function () {
        return this.item.instantGamesWinningClaimId;
    };
    InstantGameWinningNominationClaimVM.prototype.getEntityType = function () {
        return EntityTypes.InstantGamesWinningClaim;
    };
    InstantGameWinningNominationClaimVM.prototype.saveItem = function (id, changes) {
        var request = { id: id, changes: changes };
        return new Promise(function (resolve, reject) { return resolve(undefined); });
    };
    InstantGameWinningNominationClaimVM.prototype.getUpdateRoute = function () {
        return RouterConstants.RouteNames.ManageInstantGameWinningClaim;
    };
    InstantGameWinningNominationClaimVM.prototype.initializeItemForCreate = function () {
        return null;
    };
    InstantGameWinningNominationClaimVM.prototype.getListRoute = function () {
        return RouterConstants.RouteNames.ListInstantGamesWinningClaims;
    };
    InstantGameWinningNominationClaimVM = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [DialogClientService, InstantGameWinningClaimBasicMeta,
            WinningNominationClaimClientService,
            Router, BindingEngine, NotificationClientService,
            EventAggregator, I18N])
    ], InstantGameWinningNominationClaimVM);
    return InstantGameWinningNominationClaimVM;
}(BaseEntity));
export { InstantGameWinningNominationClaimVM };
